// reducers/index.js
import { combineReducers } from 'redux';
import locationReducer from './locationReducer';
// Import other reducers...

const rootReducer = combineReducers({
  locations: locationReducer,
  // Add other reducers...
});

export default rootReducer;